module.exports = __webpack_public_path__ + "img/DSC_0693.deded7ee.jpeg";